import { render, staticRenderFns } from "./labelContentList.vue?vue&type=template&id=5fdf1c5a&scoped=true"
import script from "./labelContentList.vue?vue&type=script&lang=js"
export * from "./labelContentList.vue?vue&type=script&lang=js"
import style0 from "./labelContentList.vue?vue&type=style&index=0&id=5fdf1c5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdf1c5a",
  null
  
)

export default component.exports